/**
 * Replaces v-calendar 2's `$screens` global, which v-calendar 3 removed.
 *
 * Six admin templates still call `$screens({ default: 'left', md: 'left-start' })`
 * to pick a popover placement per breakpoint. With the global gone the call
 * threw during render, which unmounted the whole page — the admin analytics and
 * affiliate-payment views came back blank.
 *
 * Breakpoints are v-calendar 2's own defaults, so the value returned at any
 * given viewport is what it was before the upgrade. Only `default` and `md` are
 * used today; the rest are kept so a template can use them without this needing
 * to change.
 */
import { reactive } from 'vue'

const BREAKPOINTS = { sm: 640, md: 768, lg: 1024, xl: 1280 }

// Ascending, so the last match wins — the largest breakpoint the viewport
// satisfies, which is what v-calendar 2 resolved to.
const ORDER = Object.keys(BREAKPOINTS).sort((a, b) => BREAKPOINTS[a] - BREAKPOINTS[b])

export default (vueInstance) => {
  const state = reactive({ width: typeof window === 'undefined' ? 0 : window.innerWidth })

  if (typeof window !== 'undefined') {
    window.addEventListener('resize', () => {
      state.width = window.innerWidth
    })
  }

  // Reading `state.width` inside the function keeps it a reactive dependency of
  // whatever computed or render calls it, so a resize re-renders as it did
  // before.
  vueInstance.config.globalProperties.$screens = (config, defaultValue) => {
    const width = state.width
    let value = Object.prototype.hasOwnProperty.call(config, 'default') ? config.default : defaultValue

    for (const name of ORDER) {
      if (width >= BREAKPOINTS[name] && Object.prototype.hasOwnProperty.call(config, name)) {
        value = config[name]
      }
    }

    return value
  }
}
